import React from 'react'
import Flexbox from 'flexbox-react'
import { observer, inject } from 'mobx-react'
import logo from '../../assets/GH_branded_Side_Panel_Header.svg'
import numberOneIcon from '../../assets/number_one_icon_new.svg'
import numberTwoIcon from '../../assets/number_two_icon_new.svg'
import numberThreeIcon from '../../assets/number_three_icon_new.svg'
import {DesignType, GraphikFont} from "../../constants"
import QRCode from 'react-qr-code'

const TEXT_COLOR = 'rgba(38, 38, 50)'

const InstructionsRow = ({ numberIcon, InstructionsText }) => {
  return (
    <Flexbox flexDirection='row' alignItems='center' justifyContent='center'>
      {numberIcon ?
        <img src={numberIcon} alt='Number Icon' style={styles.numberIcon}/> : <div style={styles.numberIcon}/>}
      <InstructionsText />
    </Flexbox>
  )
}

const InstructionsText = ({text, bold, addSpace}) => {
  let style = bold ? styles.boldInstructions : styles.instructions
  if (addSpace) {
    style = {...style, ...styles.space}
  }
  return <div style={style}>{text}</div>
}

const HallPanelQr = ({RootStore}) => {
  const {styleStore: { currentStylesDict, currentStyleName: designType }, configStore, generateGrubhubAppDeepLink } = RootStore
  const designWithTap = designType === DesignType.CHECK_IN_QR_AND_CODE_AND_TAP
  const marginTop = designWithTap ? 0 : '3.73rem'
  const marginBottom = designWithTap ? 0 : '1.35rem'

  return (
    <Flexbox height='100%' width='100%' flexDirection='column' style={{ backgroundColor: currentStylesDict.empty }}>
      <img src={logo} alt='GH Logo' />
      <Flexbox height='83%' width='100%' alignItems='center' justifyContent='center' style={styles.innerContainer}>
        <div style={{...styles.title, marginTop, marginBottom}}>
          Ready to grab your food?
        </div>
        <Flexbox alignItems='flex-start' style={styles.instructionsContainer} >
          <InstructionsRow
            numberIcon={numberOneIcon}
            InstructionsText={() => (
              <Flexbox flexDirection='column' style={styles.textContainer}>
                <Flexbox flexDirection='row'>
                  <InstructionsText text={'Open'} addSpace />
                  <InstructionsText text={'order tracking'} bold />
                </Flexbox>
                <InstructionsText text={'on the Grubhub app'} />
              </Flexbox>
            )}
          />
          <InstructionsRow
            numberIcon={numberTwoIcon}
            InstructionsText={() => (
              <Flexbox flexDirection='row'>
                <InstructionsText text={'Click the'} addSpace />
                <InstructionsText text={'check-in button'} bold />
              </Flexbox>
            )}
          />
          {designWithTap ?
            <React.Fragment>
              <InstructionsRow
                numberIcon={numberThreeIcon}
                InstructionsText={() => (
                  <Flexbox flexDirection='column' style={styles.textContainer}>
                    <Flexbox flexDirection='row'>
                      <InstructionsText text={'Tap your phone'} bold addSpace />
                      <InstructionsText text={'on the'} />
                    </Flexbox>
                    <InstructionsText text={'check-in sign'} />
                  </Flexbox>
                )}
              />
              <InstructionsRow
                InstructionsText={() => (
                  <Flexbox flexDirection='column' style={styles.textContainer}>
                    <InstructionsText text={'Or check-in using the'} addSpace />
                    <InstructionsText text={'QR or code below'} bold />
                  </Flexbox>
                )}
              />
            </React.Fragment>
            :
            <React.Fragment>
              <InstructionsRow
                numberIcon={numberThreeIcon}
                InstructionsText={() => (
                  <Flexbox flexDirection='column' style={styles.textContainer}>
                    <InstructionsText text={'Check-in using the'} addSpace />
                    <InstructionsText text={'QR or code below'} bold />
                  </Flexbox>
                )}
              />
              <div style={styles.gap}></div>
            </React.Fragment>

          }
          <Flexbox flexDirection='column' alignItems='center' justifyContent='center' width='100%' style={styles.qrContainer}>
            <QRCode
              value={generateGrubhubAppDeepLink()}
              level={'H'}
              style={styles.qrImage}
            />
            <div style={styles.qrCodeText}>
              {configStore.qrCode}
            </div>
          </Flexbox>
        </Flexbox>
      </Flexbox>
    </Flexbox>
  )
}

const styles = {
  title: {
    fontSize: '2.83rem',
    fontFamily: GraphikFont.BOLD,
    color: TEXT_COLOR,
  },
  instructions: {
    fontSize: '2.23rem',
    fontFamily: GraphikFont.LIGHT,
    color: TEXT_COLOR,
  },
  boldInstructions: {
    fontSize: '2.23rem',
    fontFamily: GraphikFont.SEMI_BOLD,
    color: TEXT_COLOR,
  },
  space: {
    marginRight: '0.675rem',
  },
  numberIcon: {
    height: '4.05rem',
    width: '4.05rem',
    marginRight: '1.35rem',
  },
  innerContainer: {
    flexDirection: 'column',
    gap: '2.36rem',
  },
  qrCodeText: {
    fontFamily: GraphikFont.SEMI_BOLD,
    fontSize: '3.3rem',
    marginTop: '1.35rem',
    color: 'black',
  },
  textContainer: {
    gap: '0.24rem',
  },
  instructionsContainer: {
    flexDirection: 'column',
    height: '82%',
    gap: '2.03rem',
  },
  gap: {
    height: '0.67rem',
  },
  qrContainer: {
    height: '42%',
  },
  qrImage: {
    borderRadius: '1rem',
    backgroundColor: 'white',
    padding: '1rem',
    width: '12rem',
    height: '12rem',
  },
}

export default inject('RootStore')(observer(HallPanelQr))



// WEBPACK FOOTER //
// ./src/components/shop_panel/hall_panel_qr.jsx